import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'thead' };

class TableHead extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-table__header',
            className,
        ];
    }

}

TableHead.propTypes = propTypes;

TableHead.defaultProps = defaultProps;

export default TableHead;
